import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { authName } from "../utils/config";
import AuthLayout from "../layout/AuthLayout";

const AuthRoutes: React.FC = () => {
  const isAuth = Boolean(window.localStorage.getItem(authName));

  if (isAuth) {
    return <Navigate to="/" replace />;
  }

  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
};

export default AuthRoutes;
